import React from 'react';
import { Outlet, useParams, Link, useLocation } from 'react-router-dom';
import Breadcrums from '../../common/breadcrumbs';
import { useTranslation } from "react-i18next";

const GeneralSeller = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const loc = useLocation();

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("User Details"),
            url: "/admin/streamers/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];


    const isStreamerTab = loc.pathname === `/admin/streamers/view/${params?.id}`;
   const isTransactionsTab = loc.pathname.includes('/transactions');


    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="tabs-wrap">
                                <div className="profile-tab tab-menu-heading mb-4">
                                    <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100">
    <Link 
        to={`/admin/streamers/view/${params?.id}`}
        className={"nav-link linkactive" + (isStreamerTab ? " active" : "")}>
        User
    </Link>
    <Link 
        to={`/admin/streamers/view/${params?.id}/transactions/1`}
        className={"nav-link linkactive" + (isTransactionsTab ? " active" : "")}>
        {t("title_transactions")}
    </Link>
</nav>
                                </div>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GeneralSeller;
